import { createSlice } from '@reduxjs/toolkit';
import apiClient from '../Api/api_client';
import { loadingSlice } from './LoadingStore';

export const defaultGameState = {
    activeGames: [],
};

// REDUCERS
// basic actions that affect this object only

const getGameReducer = (state, action) => {
    return {
        ...state,
        activeGames: action.payload.games,
    };
};

const resetReducer = (state, action) => {
    return {
        ...defaultGameState,
    };
};

const setEntryFlashGameFlagReducer = (state, action) => {
    return {
        ...defaultGameState,
    };
};

export const gameSlice = createSlice({
    name: 'game',
    initialState: defaultGameState,
    reducers: {
        getGames: getGameReducer,
        reset: resetReducer,
        setEntryFlashGameFlag: setEntryFlashGameFlagReducer,
    },
});

// ACTUAL ACTIONS
// a place to make the actions more complex if necessary

const getGames = async (dispatch, payload) => {
    dispatch(loadingSlice.actions.setLoading({ action: 'getGames' }));
    const result = await apiClient.getGames(payload);
    dispatch(gameSlice.actions.getGames(result));
    dispatch(loadingSlice.actions.unsetLoading({ action: 'getGames' }));
};

const setEntryFlashGameFlag = async (dispatch, payload) => {
    dispatch(loadingSlice.actions.setLoading());
    const result = await apiClient.setEntryFlashGameFlag(payload);
    dispatch(gameSlice.actions.setEntryFlashGameFlag(result));
    dispatch(loadingSlice.actions.unsetLoading());
};

// actions that get exported to the views
export const gameActions = (dispatch) => {
    return {
        getActiveGames: (payload) => getGames(dispatch, payload),
        reset: (payload) => dispatch(gameSlice.actions.reset(payload)),
        setEntryFlashGameFlag: (payload) => setEntryFlashGameFlag(dispatch, payload),
    };
};
